import { FeathersModel } from './feathersModel'
import { AllocationRole } from './user'

export type UserCredentialsLocation = {
  id: number
  name: string
  allocationId: number
  locationRoles: { [key in AllocationRole]: boolean }
}

/**
 * UserCredentials model represents the user's allocation roles and permissions
 * for a given social service and its locations.
 *
 * Used for managing and displaying user permissions & locations related to a specific social service.
 */
export class UserCredentials extends FeathersModel {
  /**
   * The Feathers service name for user credentials.
   */
  static serviceName = 'features/user-credentials'

  /**
   * Allocation roles for the user, including social service and locations.
   */
  allocationRoles: {
    socialService: {
      id: number
      name: string
    }
    locations: UserCredentialsLocation[]
  }

  updateFromProps(props: any): this {
    if (props.allocationRoles) {
      this.allocationRoles = props.allocationRoles
    }
    return this
  }
}
